import arrowSvg from '../assets/images/icons/iconArrow.svg';
import backSvg from '../assets/images/icons/back.svg';
import buildingSvg from '../assets/images/icons/building.svg';
import closeSvg from '../assets/images/icons/close.svg';
import crossSvg from '../assets/images/icons/cross.svg';
import cornerstoneSvg from '../assets/images/icons/cornerstone.svg';
import customersSvg from '../assets/images/icons/value-to-customer.svg';
import digitalSvg from '../assets/images/icons/digital.svg';
import digitalThreeSixtySvg from '../assets/images/icons/360.svg';
import downSvg from '../assets/images/icons/down.svg';
import electricalSvg from '../assets/images/icons/electrical.svg';
import engineersSvg from '../assets/images/icons/engineers.svg';
import environmentSvg from '../assets/images/icons/environment.svg';
import exitSvg from '../assets/images/icons/exit.svg';
import factorySvg from '../assets/images/icons/factory.svg';
import financialSvg from '../assets/images/icons/financial.svg';
import footprintSvg from '../assets/images/icons/footprint.svg';
import globeSvg from '../assets/images/icons/globe.svg';
import handshakeSvg from '../assets/images/icons/handshake.svg';
import houseSvg from '../assets/images/icons/house.svg';
import healthSvg from '../assets/images/icons/health.svg';
import laptopSvg from '../assets/images/icons/laptop.svg';
import interactiveSvg from '../assets/images/icons/interactive.svg';
import newsSvg from '../assets/images/icons/news.svg';
import openSvg from '../assets/images/icons/open.svg';
import portfolioSvg from '../assets/images/icons/portfolio.svg';
import powerQualitySvg from '../assets/images/icons/power-quality.svg';
import powerSupplySvg from '../assets/images/icons/power-supply.svg';
import powerTransmissionSvg from '../assets/images/icons/power-transmission.svg';
import pggiSvg from '../assets/images/icons/grid.svg';
import publicationSvg from '../assets/images/icons/publication.svg';
import renewablesSvg from '../assets/images/icons/renewables.svg';
import safetySvg from '../assets/images/icons/safety.svg';
import scrollSvg from '../assets/images/icons/scroll.svg';
import securitySvg from '../assets/images/icons/security.svg';
import substationSvg from '../assets/images/icons/substation.svg';
import timelineArrowSvg from '../assets/images/icons/timeline.svg';
import timelineSvg from '../assets/images/icons/timeline-icon.svg';
import stageArrowSvg from '../assets/images/icons/stageArrow.svg';
import swipeSvg from '../assets/images/icons/swipe-down.svg';
import whiteFactorySvg from '../assets/images/icons/white-factory.svg';
import whiteCornerstoneSvg from '../assets/images/icons/cornerstone-white.svg';
import whiteNewsSvg from '../assets/images/icons/white-news.svg';
import whitePowerQualitySvg from '../assets/images/icons/white-power-quality.svg';
import whitePowerSupplySvg from '../assets/images/icons/white-power-supply.svg';
import whitePowerTransmissionSvg from '../assets/images/icons/white-power-transmission.svg';
import whiteSubstationSvg from '../assets/images/icons/white-substation.svg';
import whiteValueCustomerSvg from '../assets/images/icons/white-value-to-customer.svg';
import whiteRenewablesSvg from '../assets/images/icons/white-renewables.svg';
import upSvg from '../assets/images/icons/up.svg';


import powerSvg from '../assets/images/icons/power.svg';
import manualSvg from '../assets/images/icons/manual.svg';
import officeSvg from '../assets/images/icons/office.svg';

const icons = {
	manual: {
		svg: manualSvg,
	},
	office: {
		svg: officeSvg,
	},
	power: {
		svg: powerSvg,
	},
	exit: {
		svg: exitSvg,
	},
	arrow: {
		svg: arrowSvg,
	},
	close: {
		svg: closeSvg,
	},
	pggi: {
		svg: pggiSvg,
	},
	factory: {
		svg: factorySvg,
	},
	house: {
		svg: houseSvg,
	},
	news: {
		svg: newsSvg,
	},
	powerQuality: {
		svg: powerQualitySvg,
	},
	powerSupply: {
		svg: powerSupplySvg,
	},
	powerTransmission: {
		svg: powerTransmissionSvg,
	},
	substation: {
		svg: substationSvg,
	},
	customers: {
		svg: customersSvg,
	},
	cornerstone: {
		svg: cornerstoneSvg,
	},
	open: {
		svg: openSvg,
	},
	whiteCornerstone: {
		svg: whiteCornerstoneSvg,
	},
	whiteFactory: {
		svg: whiteFactorySvg,
	},
	whiteNews: {
		svg: whiteNewsSvg,
	},
	whitePowerQuality: {
		svg: whitePowerQualitySvg,
	},
	whitePowerTransmission: {
		svg: whitePowerTransmissionSvg,
	},
	whitePowerSupply: {
		svg: whitePowerSupplySvg,
	},
	whiteSubstation: {
		svg: whiteSubstationSvg,
	},
	whiteValueCustomer: {
		svg: whiteValueCustomerSvg,
	},
	up: {
		svg: upSvg,
	},
	down: {
		svg: downSvg,
	},
	timelineArrow: {
		svg: timelineArrowSvg,
	},
	digital: {
		svg: digitalSvg,
	},
	electrical: {
		svg: electricalSvg,
	},
	financial: {
		svg: financialSvg,
	},
	swipe: {
		svg: swipeSvg,
	},
	back: {
		svg: backSvg,
	},
	building: {
		svg: buildingSvg,
	},
	environment: {
		svg: environmentSvg,
	},
	health: {
		svg: healthSvg,
	},
	safety: {
		svg: safetySvg,
	},
	timeline: {
		svg: timelineSvg,
	},
	engineers: {
		svg: engineersSvg,
	},
	publication: {
		svg: publicationSvg,
	},
	portfolio: {
		svg: portfolioSvg,
	},
	interactive: {
		svg: interactiveSvg,
	},
	security: {
		svg: securitySvg,
	},
	laptop: {
		svg: laptopSvg,
	},
	handshake: {
		svg: handshakeSvg,
	},
	globe: {
		svg: globeSvg,
	},
	stageArrow: {
		svg: stageArrowSvg,
	},
	scroll: {
		svg: scrollSvg,
	},
	cross: {
		svg: crossSvg,
	},
	digitalThreeSixty: {
		svg: digitalThreeSixtySvg,
	},
	footprint: {
		svg: footprintSvg,
	},
	renewables: {
		svg: renewablesSvg,
	},
	whiteRenewables: {
		svg: whiteRenewablesSvg,
	},
};

export default icons;



// WEBPACK FOOTER //
// ./src/data/icons.js